<template>
  <TitleCard :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="head-top-wrap">
        <TableTotalWrap :result="totalCounts" :auditStatus="auditStatus" @change="handlerStatusCheck"></TableTotalWrap>
        <div class="form-table-wrap">
          <Form
            ref="form"
            layoutType="grid"
            :optionList="formRow"
            :defaultModel="defaultValue"
          ></Form>
          <div class="operation-wrap">
            <a-button @click="clearAll">清空条件</a-button>
            <a-button @click="toSearch">搜索</a-button>
          </div>
        </div>
        <TableToolsWrap
          needLeft
          :btnList="utilsBtnList"
          @utilsClick="handlerActionClick"
        ></TableToolsWrap>
      </div>
      <Table
        ref="table"
        :options="fields"
        :tableValue="tableValue"
        :customSlotOpt="slotOpt"
        @change="initTableValue"
        :otherOpt="customOtherOpt"
        @actionClick="handlerActionClick"
      ></Table>
    </div>
    <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
  </TitleCard>
</template>

<script>
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import TableTotalWrap from '../../components/common/tableTotalWrap.vue'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
// import makeFakerData from '@/mixins/makeFakerData'
import AModal from '../../components/AModal'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { fields, slotOpt, formRow } from './configs/configs'
import { getInfo, statusInfo, getCounts } from '@/api/operationInfo.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      slotOpt,
      fields,
      formRow,
      tableValue: [],
      defaultSearchParam: {}, // 默认筛选条件
      auditStatus: '0',
      utilsBtnList: [ ],
      customOtherOpt: { // 传入表格中的分页器配置
        pagination: {
          total: 0,
          pageSize: 10,
          pageNum: 1
        }
      },
      totalCounts: [], // 头部的统计值
      defaultValue: { // 表格默认值
        searchValue: '0'
      },
    }
  },
  components: {
    TableTotalWrap,
    TableToolsWrap,
    Table,
    Form,
    AModal
  },
  mounted() {
    this.initSearchParams() // 重置搜索的参数
    this.initTableValue()
    this.getTotalCount(getCounts) // 获取表格的统计数量
    this.handlerTableSlot()
    this.handlerTableHeadOperationBtn()
  },
  methods: {
     handlerStatusCheck(v) {
      this.auditStatus = v
      this.initSearchParams() // 重置搜索的参数
      this.initPagination()
      // 处理操作栏
      this.initTableValue()
      this.handlerTableSlot()
      this.handlerTableHeadOperationBtn()
    },
    // 处理表格头部的控制按钮的显示
    handlerTableHeadOperationBtn() {
      const forbiddenMap = ['1', '2'] // 待审核 和 不通过不显示发布和下架功能
      let utilsBtnList = []
      if(!forbiddenMap.includes(this.auditStatus)) {
        utilsBtnList =  [
          { name: '通过', cb: 'batchPass' },
          { name: '不通过', cb: 'batchFail' }
        ]
      }
      this.utilsBtnList = utilsBtnList
    },
    // 处理表格的操作按钮
    handlerTableSlot() {
      const status = this.auditStatus
      const target = this.slotOpt.find(item => item.slot === 'action')
      if(!target) return
      let initSlot = []
      if(status === '0') {
        initSlot = [
          { name: '通过', cb: 'pass' },
          { name: '不通过', cb: 'noPass', divider: true }
        ]
      }
      target.list = initSlot
    },
    async initTableValue() {
      try {
        this.loadingTable(true) // 开启表格的加载动画
        const params = this.dealSearchFormParams()
        const { data } = await getInfo(params) // 请求表格数据接口
        const { rows, total } = data
        const row = this.handlerDateFormat(rows)
        this.handlerResultMappings(rows) // 处理数据的映射关系
        this.tableValue = row
        this.customOtherOpt.pagination = {
          total: total
        }
        this.initSelectedRowIds() // 清空勾选的选项
      } catch (error) {
        console.log(error)
        this.$apiStatusHandler(99, error.msg) // 请求异常，则全局轻提示
      } finally {
        this.loadingTable(false)
      }
    },
    // 处理搜索表单的值
    dealSearchFormParams() {
      const { pagination } = this.$refs.table
      const {pageSize, pageNum} = pagination
      const params = {
        ...this.searchParam,
        pageNum,
        pageSize
      }
      return params
    },
    pass(row) {
      const { id } = row
      this.customModalOpt.contentTips = '是否确定通过审核'
      this.beforeShowModal(true, {
        source: 'dealAuditApi',
        params: { auditStatus: 1, ids: [id] }
      })
    },
    // 单个通过
    async dealAuditApi(params) {
      const {msg, code} = await statusInfo(params)
      this.$apiStatusHandler(code, msg)
      this.initTableValue()
      this.getTotalCount(getCounts)  // 获取表格的统计数量
    },
    noPass(row) {
      const { id } = row
      this.customModalOpt.contentTips = '是否确定不通过审核'
      this.beforeShowModal(true, {
        source: 'dealNoPassApi',
        params: { auditStatus: 2, ids: [id] }
      })
    },
    // 单个不通过
    async dealNoPassApi(params) {
      const {msg, code} = await statusInfo(params)
      this.$apiStatusHandler(code, msg)
      this.initTableValue()
      this.getTotalCount(getCounts)  // 获取表格的统计数量
    },
    // 批量操作
    async batch(params) {
      const {msg, code} = await statusInfo(params)
      this.$apiStatusHandler(code, msg)
      this.initTableValue()
      this.getTotalCount(getCounts)  // 获取表格的统计数量
    },
    // 批量通过
    batchPass() {
      const ids = this.$refs.table.selectedRowIds
      const id = ids.map((item) => item.id)
      if(id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的内容')
      }
      this.customModalOpt.contentTips = '是否确定通过选中的信息的审核'
      this.beforeShowModal(true, {
        source: 'batch',
        params: { auditStatus: 1, ids: id }
      })
    },
    // 批量不通过
    batchFail() {
      const ids = this.$refs.table.selectedRowIds
      const id = ids.map((item) => item.id)
      if(id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的内容')
      }
      this.customModalOpt.contentTips = '是否确定不通过选中的信息的审核'
      this.beforeShowModal(true, {
        source: 'batch',
        params: { auditStatus: 2, ids: id }
      })
    },
    // 前往详情
    toDetail(row) {
      const {id} = row.scope
      this.$router.push({ name: 'operationIssue', query:{ id, type: 'detail' }})
    },
  }
}
</script>
